import { render, staticRenderFns } from "./MerchantsData.vue?vue&type=template&id=8c35e3fc&scoped=true&"
import script from "./MerchantsData.vue?vue&type=script&lang=js&"
export * from "./MerchantsData.vue?vue&type=script&lang=js&"
import style0 from "./MerchantsData.vue?vue&type=style&index=0&id=8c35e3fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c35e3fc",
  null
  
)

export default component.exports